import { createGlobalStyle, keyframes } from 'styled-components';
import { ThemeDefinitions } from './ThemeComponents';

const waveTop = keyframes`
from {

  top: -210px;
  transform: rotateX(0deg);
}
to{

  top: -180px;
  transform: rotateX(30deg);
}
`;

const waveBottom = keyframes`
from {

  bottom: -210px;
  transform: rotateX(0deg);
}
to{

  bottom: -180px;
  transform: rotateX(30deg);

}
`;

const glitch = keyframes`
0% {
  transform: skew(0deg);
  Dropshadow: 0;

}
50% {
  transform: skew(-10deg);
  Dropshadow: -2px -2px 2px rgb(0,100,200);
}
10%{

  transform: skew(10deg);
  Dropshadow: -2px -2px 2px rgb(200,100,0);

}
`;

const shadowKey = keyframes`
0% {
  transform:translateY(0);
-webkit-filter: drop-shadow(0px 12px 25px rgba(0,0,0,0.5));

-ms-filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=12, Color='#444')";
filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=12, Color='#444')";
filter: drop-shadow(0px 12px 25px rgba(0,0,0,0.5));
}
50%{
  transform:translateY(-10px);
  -webkit-filter: drop-shadow(0px 12px 25px rgb(0,102,178));

-ms-filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=12, Color='rgb(0,102,178)')";
filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=12, Color='rgb(0,102,178)')";
filter: drop-shadow(0px 12px 25px rgb(0,102,178));

}
100% {
  transform:translateY(0);
-webkit-filter: drop-shadow(0px 12px 25px rgba(0,0,0,0.5));

-ms-filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=12, Color='#444')";
filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=0, OffY=12, Color='#444')";
filter: drop-shadow(0px 12px 25px rgba(0,0,0,0.5));
}
`;

export default createGlobalStyle`

@font-face {
    font-family: Montserrat;
    src: url("/assets/fonts/Montserrat-Regular.ttf") format("truetype");
}


@font-face {
    font-family: MontserratBold;
    src: url("/assets/fonts/Montserrat-Bold.ttf") format("truetype");
}


*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  outline: 0
}

html{
  width: 100%;
  min-height: 100vh !important;

  background-attachment: fixed;
  background-size: cover;
  background: #fff;



}

body {
  background: #fff;
  background: url('/assets/evento/Fundo.jpg') no-repeat center;
  background-size: cover;
  background-attachment: fixed;
  color: #fff;
  -webkit-font-smoothing: antialiased;
  padding: 0;
  margin: 0 !important;
  min-height: 100vh !important;
  min-height: 100% !important;
  position: relative;



}

#root{
  min-height: 100vh;

}

body, input, button{
  font-family: Helvetica,  sans-serif;
  font-size: 16px;
}

h1,h2,h3,h4,h5,h6, strong{
font-weight: bold;
font-family:  'MontserratBold',Helvetica,  sans-serif;

}

h2{

      font-size: 16px;
}

p, span{
  font-family:'Montserrat',Helvetica,  sans-serif;
}

p, span, li, nav{
  font-family:'Montserrat',Helvetica,  sans-serif;
  line-height: 1.3rem;
  list-style:none;
}


button{
  cursor: pointer;
}

strong {
  display: inline !important;
}

.wave {

  width: 200%;
  margin-left: -20%;
  z-index:0;

  @media (max-width: 1250px) {
    width: 400%;
    margin-left: -50%;
  }

  @media (max-width: 750px) {
    width: 800%;
    margin-left: -50%;
  }



}

.fixedTop {
 position: fixed;
 top: -210px;
 animation: ${waveTop} 5s infinite alternate-reverse ease;
 left: 0;
}

.fixedBottom{
  position: fixed;
 bottom: -210px;
 animation: ${waveBottom} 5s infinite alternate-reverse;
 left: 0;

}

.computerOnly{
display: flex;
@media (max-width: 1200px) {
    display: none;
  }
}

.mobileOnly{
display: none;
@media (max-width: 1200px) {
    display: flex;
  }
}

button.defaultButton {
         margin-top: 10px;
      width: 200px;
      min-width: 200px;
      padding: 20px;
      text-align: center;
      background: #0D3E64 !important;
      color: #fff  !important;

      transition: background 0.5s;
      border: 0;
      border-radius: 8px;

      &:hover {
        background: #0D3E64  !important;
      }
    }

    button.defaultButtonMini {
         margin-top: 10px;
      width: 50px !important;
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 20px;
      height: 30px;
      text-align: center;
      background: #0D3E64 !important;
      color: #fff  !important;

      transition: background 0.5s;
      border: 0;
      border-radius: 8px;

      &:hover {
        background: #0D3E64  !important;
      }
    }

    a {
      text-decoration: none !important;
    }

    .shadowed {
    -webkit-filter: drop-shadow(12px 12px 25px rgba(0,0,0,0.5));

    -ms-filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=12, OffY=12, Color='#444')";
    filter: "progid:DXImageTransform.Microsoft.Dropshadow(OffX=12, OffY=12, Color='#444')";
    filter: drop-shadow(12px 12px 25px rgba(0,0,0,0.5));

    animation : ${shadowKey} 1s infinite;
}

.glitched {


    animation : ${glitch} 0.5s infinite alternate-reverse;
}

.colorWhite{
  color : #fff !important;
}



input, select{
  font-family: Montserrat, sans-serif !important;
  font-weight: 400 !important;
  font-size: 14px !important;





/*Change text in autofill textbox*/
&:-webkit-autofill,
&:-webkit-autofill:hover,
&:-webkit-autofill:focus,
&:-webkit-autofill:active {
    -webkit-transition: "color 9999s ease-out, background-color 9999s ease-out";
    -webkit-transition-delay: 9999s;
}
}

.greenBall{
    background: rgb(0, 182, 18);
    width: 10px;
    height: 10px;
    min-width: 10px;
    min-height: 10px;
    max-width: 10px;
    max-height: 10px;
    margin: 5px 10px;
    border-radius: 50%;
    display: flex;
  }

  .titleLine,
  .titleSubLine {
    color: rgb(0, 102, 178);

    display: flex;

    flex-wrap: wrap;
    max-width: 350px;
    width: 100%;

    justify-content: left;
    font-size: 32px;
    margin: 0;

    @media (max-width: 1200px) {
      justify-content: center;
    }
  }

  .titleSubLine {
    color: rgb(0, 182, 18);
    font-weight: 400 !important;
    font-size: 18px;
  }


  .titleSkewRight, .titleSkewRightDark{
    display: flex;
    border-radius: 0px;
    background: rgb(249,126,19);
    transition: 0.5s all;
    padding: 10px 20px;
    margin: 5px auto;
    justify-content: center;
    margin: 0 10px;
    transform: skewX(-31deg) !important;

    > h2{
      transform: skewX(31deg) !important;
      color: #fff;
      font-size: 40px;

      @media (max-width: 750px) {
        font-size: 18px;
  }
    }

    > h3,> button{ cursor: pointer;
      transform: skewX(31deg) !important;
      color: #fff;
      font-size: 16px;
    }

    &:hover {
        background: rgb(252,175,23);
        > h3, > button{
          background:  rgb(252,175,23);
        }
      }

  }


  .titleSkewRightDark{

    background: rgb(252,175,23);

    > h2, > button, >h3{
          background: rgb(252,175,23);
        }



  }

`;
